import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { forwardRef } from "react";
import { margin } from "styled-system";
import styled from "styled-components";
import { RightOutlined } from "../../icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AccordionIcon = styled(RightOutlined).withConfig({
  displayName: "accordion__AccordionIcon",
  componentId: "sc-m0zahz-0"
})(["margin-right:8px;transition:transform 0.3s ", ";"], p => p.theme.transitions.easeOut);
const AccordionTrigger = styled(AccordionPrimitive.Trigger).withConfig({
  displayName: "accordion__AccordionTrigger",
  componentId: "sc-m0zahz-1"
})(["all:unset;flex:1;background:transparent;padding:12px 16px;line-height:1;color:", ";font-family:", ";transition:all 0.3s;cursor:pointer;&:focus{outline:none;}&[data-state=\"open\"] ", "{transform:rotate(90deg);}&[data-disabled]{color:", ";cursor:not-allowed;}"], p => p.theme.colors.heading, p => p.theme.fonts.secondary, AccordionIcon, p => p.theme.colors.disabled);
const AccordionHeader = styled(AccordionPrimitive.Header).withConfig({
  displayName: "accordion__AccordionHeader",
  componentId: "sc-m0zahz-2"
})(["all:unset;position:relative;display:flex;justify-content:space-between;align-items:center;"]);
const AccordionExtra = styled.div.withConfig({
  displayName: "accordion__AccordionExtra",
  componentId: "sc-m0zahz-3"
})(["padding:0 12px;"]);
const AccordionContent = styled(AccordionPrimitive.Content).withConfig({
  displayName: "accordion__AccordionContent",
  componentId: "sc-m0zahz-4"
})(["color:", ";background:", ";border-top:", ";&[data-state=\"closed\"]{display:none;}"], p => p.theme.colors.text, p => p.theme.colors.bg.component, p => p.theme.borders.base);
const AccordionContentText = styled.div.withConfig({
  displayName: "accordion__AccordionContentText",
  componentId: "sc-m0zahz-5"
})(["padding:16px;"]);
const AccordionItem = styled(AccordionPrimitive.Item).withConfig({
  displayName: "accordion__AccordionItem",
  componentId: "sc-m0zahz-6"
})(["border-bottom:", ";overflow:hidden;&:focus-within{box-shadow:0 0 0 2px ", ";}&:first-of-type{border-radius:", "px ", "px 0 0;}&:last-of-type{border-radius:0 0 ", "px ", "px;}"], p => p.theme.borders.base, p => p.theme.colors.focus, p => p.theme.radii.base, p => p.theme.radii.base, p => p.theme.radii.base, p => p.theme.radii.base);
const AccordionRoot = styled(AccordionPrimitive.Root).withConfig({
  displayName: "accordion__AccordionRoot",
  componentId: "sc-m0zahz-7"
})(["background:", ";border:", ";border-radius:", "px;border-bottom:0;", " &[data-bordered=\"false\"]{border:0;", ":last-of-type{border-bottom:none;}", "{position:relative;background-color:transparent;border-top:0;&::before{position:absolute;top:0;left:16px;width:calc(100% - 32px);border-top:1px solid ", ";content:\"\";}}}"], p => p.theme.colors.light.bg, p => p.theme.borders.base, p => p.theme.radii.base, margin, AccordionItem, AccordionContent, p => p.theme.colors.alpha[1]);
const AccordionPanel = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    value,
    disabled = false,
    header,
    extra,
    children
  } = _ref;
  return /*#__PURE__*/_jsxs(AccordionItem, {
    ref: ref,
    value: value,
    disabled: disabled,
    children: [/*#__PURE__*/_jsxs(AccordionHeader, {
      children: [/*#__PURE__*/_jsxs(AccordionTrigger, {
        children: [/*#__PURE__*/_jsx(AccordionIcon, {
          "aria-hidden": true
        }), header]
      }), extra ? /*#__PURE__*/_jsx(AccordionExtra, {
        children: extra
      }) : null]
    }), /*#__PURE__*/_jsx(AccordionContent, {
      forceMount: true,
      children: /*#__PURE__*/_jsx(AccordionContentText, {
        children: children
      })
    })]
  });
});
export const Accordion = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    bordered = true,
    children,
    ...rest
  } = _ref2;
  return /*#__PURE__*/_jsx(AccordionRoot, {
    ref: ref,
    ...rest,
    "data-bordered": bordered,
    children: children
  });
});
export default Object.assign(Accordion, {
  Panel: AccordionPanel
});